module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.value,
      "placeholder": "请选择",
      "size": "mini",
      "disabled": _vm.disabled,
      "clearable": ""
    },
    on: {
      "visible-change": _vm.visibleChange,
      "clear": _vm.clear
    }
  }, [_c('el-option', {
    ref: "option",
    staticClass: "option",
    attrs: {
      "value": _vm.optionData.id,
      "label": _vm.optionData.name
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "tree",
    attrs: {
      "node-key": _vm.nodeKey,
      "data": _vm.data,
      "props": _vm.props,
      "default-expanded-keys": [_vm.value],
      "highlight-current": "",
      "expand-on-click-node": false
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-648200e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648200e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SelectTree.vue
// module id = 1582
// module chunks = 7